import { StipulatorConfigurationService } from '@philips-emr/hpms-stipulator-commons';
import { ImageAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { ThemeService } from '@philips-emr/tws-core/lib/services';

import BaseController from '../BaseController';

@Controller({ fragment: 'confirmar-usuario-falha' })
export default class ConfirmarUsuarioFalhaController extends BaseController {
  @OnMount({ target: 'login-image-header' })
  onMountLogo(event: MouseEvent): void {
    ThemeService.setContentTonalRange(StipulatorConfigurationService.getTonalidadeLogin());
    const api = event.target as unknown as ImageAPI;

    void StipulatorConfigurationService.getConfigurationData()
      .then(data => api.setSrc(data.dsUrlLogoHeaderLogin as string));
  }
}
